import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Logo",
    style: _normalizeStyle({ height: __props.size + 'px' })
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "h-full",
      src: "images/crs-i-logo-bw 1.png",
      alt: "Poslednik Logo"
    }, null, -1)
  ]))], 4))
}
}

})